import type { FavoriteStore } from '~/interfaces/favorites'
import { normalizeFavoriteStoreId } from './normalizeFavoriteStoreId'

/** Adds `store` to the list unless already present, or removes its first match, mutating in place. */
export const applyFavoriteStoreChange = (
  favoriteStores: FavoriteStore[],
  storeId: number,
  store: FavoriteStore,
  isAdding: boolean
): void => {
  const index = favoriteStores.findIndex(
    (favoriteStore) => normalizeFavoriteStoreId(favoriteStore.id) === storeId
  )

  if (isAdding) {
    if (index === -1) favoriteStores.push(store)
    return
  }

  if (index > -1) favoriteStores.splice(index, 1)
}
